<template>
  <div style="padding:15px;" class="containerTable">
    <vxe-toolbar
      id="toolbarId_fa1"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button v-if="getLimit('carrier_search_button')" @click="funcFilter"
          >查询</el-button
        >
        <el-date-picker
          v-model="listQuery.gmtCreatedRange"
          type="daterange"
          value-format="yyyy-MM-dd"
          :picker-options="optionsPicker"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="value => changeDate(value, 'gmtCreated')"
        />
        <el-button v-if="getLimit('carrier_export_button')" @click="funcExport"
          >导出</el-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      resizable
      border
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      show-footer
      :footer-method="footerMethod"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="name" title="姓名" min-width="130" sortable />
        <template v-slot:header>
          <el-input
            v-model="listQuery.name"
            placeholder="请输入姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="phone"
          title="手机号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="请输入手机号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="orderCount" title="运单数" min-width="130" />
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="deliveryFeePractical"
          title="运费（元）"
          min-width="130"
        />
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="basicGrade" title="评价分数" min-width="130" />
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import request from "@/utils/request";
export default {
  name: "PartyList",
  components: {},
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      exportObj: {
        exportUrl: "/ntocc-tms-api/statistics/exportDriverOrderStatistics", //导出接口
        name: "承运报表"
      },
      listQuery: {
        name: "", // 名称
        phone: "", // 电话
        orderCount: "", // 订单数
        deliveryFeePractical: "", // 运费（元）
        basicGrade: "", // 评价分数
        gmtCreatedStart: "", // 创建时间起始
        gmtCreatedEnd: "", // 创建时间终止
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: ""
      },
      roleList: [],
      sumObject: {},
      // 机构列表
      branchList: this.$store.state.components.branchList
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        request({
          url: "ntocc-tms-api/statistics/driverOrderStatistics",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.findList();
    },
    // 合计
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (column.property === "deliveryFeePractical") {
            return this.sumObject.deliveryFeePractical;
          }
          return "-";
        })
      ];
    }
  }
};
</script>
